export const settings = {
  siteName: process.env.REACT_APP_TITLE,
  dashboardRoute: '/',
  hasPublicPage: false,
  API_URL: process.env.REACT_APP_API_URL,
  ADMIN_URL: process.env.REACT_APP_ADMIN_URL,
  ASSETS_URL: process.env.REACT_APP_ASSETS_URL,
  TOKEN: process.env.REACT_APP_TOKEN,
  DOMAIN: process.env.REACT_APP_DOMAIN,
  REDIRECT_MOBILE: process.env.REACT_APP_REDIRECT_MOBILE,
  perPage: 12,
  pagination: {
    pageRangeDisplayed: 3,
    hideDisabled: true,
    hideFirstLastPages: false,
    hideNavigation: true,
    linkClassFirst: 'arrow first',
    linkClassPrev: 'arrow prev',
    linkClassNext: 'arrow next',
    linkClassLast: 'arrow last',
  },
  GOOGLE_API_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
  GEONAMES_USERNAME: process.env.REACT_APP_GEONAMES_USERNAME,
  firebaseConfig: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
  },
  reacptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
  vapidKey: process.env.REACT_APP_VAPID_PUBLIC_KEY,
  serverKey: process.env.REACT_APP_SERVER_KEY,
  initialPageUri: process.env.REACT_APP_INITIAL_PAGE_URI,
}
